module.exports = __webpack_public_path__ + "img/2.4868ef6c.svg";